// extracted by mini-css-extract-plugin
export default {"selection-div":"requestApprove_selection-div__flami","button-div":"requestApprove_button-div__-DvCu"};